<template>
<div>
    <v-expansion-panels>
        <!-- PROFESSIONS -->
        <v-expansion-panel>
            <v-expansion-panel-header :style="{color: item.color}">
                <span class="caption font-weight-medium">PROFESSIONS</span>
                <template v-slot:actions>
                    <v-icon :color="item.color">fa-angle-down</v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-6 pb-3 grey lighten-5">
                <div v-if="item.mytop && item.mytop.professions">
                    <ol>
                        <li v-for="it in item.mytop.professions" :key="it.id">
                            {{it}}       
                        </li>
                    </ol>
                    <!-- <v-btn text class="mt-2" :style="{color: item.color}" small v-if="item.uid == user.uid" @click="openDiag('professions')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Edit
                    </v-btn> -->
                </div>
                <div v-else>
                    <div class="body-2 grey--text">No information yet.</div>
                    <!-- <v-btn text class="mt-2 ml-n4" :style="{color: item.color}" v-if="item.uid == user.uid" @click="openDiag('professions')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Set top 3 professions
                    </v-btn> -->
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- MAJORS -->
        <v-expansion-panel>
            <v-expansion-panel-header :style="{color: item.color}">
                <span class="caption font-weight-medium">MAJORS</span>
                <template v-slot:actions>
                    <v-icon :color="item.color">fa-angle-down</v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-6 pb-3 grey lighten-5">
                <div v-if="item.mytop && item.mytop.majors">
                    <ol>
                        <li v-for="it in item.mytop.majors" :key="it.id">
                            {{it}}       
                        </li>
                    </ol>
                    <!-- <v-btn text class="mt-2" :style="{color: item.color}" small v-if="item.uid == user.uid" @click="openDiag('majors')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Edit
                    </v-btn> -->
                </div>
                <div v-else>
                    <div class="body-2 grey--text">No information yet.</div>
                    <!-- <v-btn text class="mt-2 ml-n4" :style="{color: item.color}" v-if="item.uid == user.uid" @click="openDiag('majors')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Set top 3 majors
                    </v-btn> -->
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- UNIVERSITIES -->
        <v-expansion-panel>
            <v-expansion-panel-header :style="{color: item.color}">
                <span class="caption font-weight-medium">UNIVERSITIES</span>
                <template v-slot:actions>
                    <v-icon :color="item.color">fa-angle-down</v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-6 pb-3 grey lighten-5">
                <div v-if="item.mytop && item.mytop.universities">
                    <ol>
                        <li v-for="it in item.mytop.universities" :key="it.id">
                            <span v-if="it.id=='text'">{{it.name}}</span>     
                            <span v-else 
                                @click="$router.push('/map-of-careers/best-universities/'+it.id)" 
                                style="cursor:pointer; text-decoration:underline">
                                {{it.name}}
                            </span>     
                        </li>
                    </ol>
                    <!-- <v-btn text class="mt-2" :style="{color: item.color}" small v-if="item.uid == user.uid" @click="openDiag('universities')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Edit
                    </v-btn> -->
                </div>
                <div v-else>
                    <div class="body-2 grey--text">No information yet.</div>
                    <!-- <v-btn text class="mt-2 ml-n4" :style="{color: item.color}" v-if="item.uid == user.uid" @click="openDiag('universities')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Set top 3 universities
                    </v-btn> -->
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- COMPANIES TO WORK FOR -->
        <v-expansion-panel>
            <v-expansion-panel-header :style="{color: item.color}">
                <span class="caption font-weight-medium">COMPANIES TO WORK FOR</span>
                <template v-slot:actions>
                    <v-icon :color="item.color">fa-angle-down</v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-6 pb-3 grey lighten-5">
                <div v-if="item.mytop && item.mytop.companies">
                    <ol>
                        <li v-for="it in item.mytop.companies" :key="it.id">
                            {{it}}       
                        </li>
                    </ol>
                    <!-- <v-btn text class="mt-2" :style="{color: item.color}" small v-if="item.uid == user.uid" @click="openDiag('companies')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Edit
                    </v-btn> -->
                </div>
                <div v-else>
                    <div class="body-2 grey--text">No information yet.</div>
                    <!-- <v-btn text class="mt-2 ml-n4" :style="{color: item.color}" v-if="item.uid == user.uid" @click="openDiag('companies')">
                        <v-icon :color="item.color" size="10px" left>fa-pen</v-icon>
                        Set top 3 companies
                    </v-btn> -->
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>

    <DiagTop3
        :model="showDiagTop3"
        :which="actual"
        @cancel="showDiagTop3=false"
        @close="close"
        v-if="showDiagTop3" />
</div>
</template>

<script>
import DiagTop3 from '@/components/core/dialogs/DiagTop3'
export default {
    data: () => ({
        showDiagTop3: false,
        actual: null
    }),
    props: ['item'],
    components: {
        DiagTop3
    },
    methods: {
        openDiag(item) {
            this.actual = item;
            this.showDiagTop3 = true;
        },
        close() {
            this.showDiagTop3 = false;
            this.$emit('reinit');
        }
    }
}
</script>